import { render } from "./Child.vue?vue&type=template&id=83f84682"
import script from "./Child.vue?vue&type=script&lang=ts"
export * from "./Child.vue?vue&type=script&lang=ts"
script.render = render

export default script